import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';

import TimePickerContent from './TimePickerContent';
import { TimePeriod } from '../../../shared/constants';
import ConsoleLog from './../../../hoc/ConsoleLog/ConsoleLog';

const TimePickerContainer = styled.div`
  position: relative;
  font-family: Roboto;
   @media(min-width: 800px)
`;

const TimePickerFormGroup = styled.span`
  position: relative;
  border: none;
  overflow: hidden;
`;

const TimePickerLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #323c47;
  display:block;
`;

const TimePickerWrapper = styled.div`
  float: left;
  position: relative;
  width: 58px; 
  height:71px;
  &.timepickerOpen:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 55px;
    height: 15px;
    width: 11px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 7px solid #E9EFF4;
    border-color: transparent transparent #E9EFF4 #E9EFF4;
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: rotate(135deg);
    -ms-transform: rotate(135deg);
    transform: rotate(135deg);
    z-index: 2;
  }

  &.timepickerOpen:after{
    content: "";
    position: absolute;
    left: 33px;
    bottom: 0;
    height: 24px;
    width: 23px;
    background: #fff;
    z-index: 100;
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-clip-path: polygon(50% 0,100% 50%,50% 100%,0 50%);
    clip-path: polygon(50% 0,100% 50%,50% 100%,0 50%);
  }
  @media(min-width: 800px) {    
    width: 88px; 
  }
`;

const TimePickerInput = styled.input`
  padding: 10px 4px;
  font-size: 12px;
  font-weight: 500;
  color: #323c47;
  width: 58px;
  height: 44px;
  border-radius: 4px;
  border: solid 1px #e9eff4;
  &::placeholder {
    font-size: 14px;
  }

  @media(min-width: 800px) {
    width: 88px;
    padding: 10px 15px;
    font-size: 14px;
  }
`;

class TimePicker extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      timePickerOpen: false,
      selectedTime: props.selectedTime,
      selectedTimePeriod: (moment(props.selectedTime, "HH:mm:ss") < moment("12:00:00", "HH:mm:ss")) ? "AM" : "PM",
      selectedTimeLabel: TimePeriod[0].label,
      selectedTimeId: props.selectedTimeId
    }

    this.setTimepickerRef = this.setTimepickerRef.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    this.handleSelectedTimeValue(this.state.selectedTime)
  }

  componentWillUpdate(nextProps) {
    if (nextProps.selectedTime !== this.props.selectedTime) {
      //ConsoleLog("componentWillUpdate time",nextProps.selectedTime,this.props.selectedTime)
      this.handleSelectedTimeValue(nextProps.selectedTime);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  };

  setTimepickerRef(node) {
    this.timepickerRef = node;
  }

  toggleTimepicker = () => {
    this.setState({ timePickerOpen: !this.state.timePickerOpen });
  }

  handleSelect = (selectedTimeId, event) => {
    const selectedTime = TimePeriod.find((time) => time.id === selectedTimeId).value;
    this.setState({ selectedTime: selectedTime, timePickerOpen: false }, this.handleSelectedTimeValue(selectedTime));
    this.props.handleSelect(selectedTime, event);
  }

  handleClickOutside = (event) => {
    if (this.timepickerRef && !this.timepickerRef.contains(event.target)) {
      this.setState({ timePickerOpen: false });
    }
  }

  handleTimePeriod = (selectedTimePeriod) => {
    this.setState({ selectedTimePeriod: selectedTimePeriod });
  }

  handleSelectedTimeValue = (selectedTime) => {
    const timeObject = TimePeriod.find((time) => time.value === selectedTime);
    const time = (timeObject) ? timeObject.label : "";
    const timeId = (timeObject) ? timeObject.id : 1;
    this.setState({ selectedTimeLabel: time, selectedTimeId: timeId });
  }

  render() {
    const TimePeriodArray = [...TimePeriod];
    const AMData = TimePeriodArray.filter((time) => moment(time.value, "HH:mm:ss") < moment("12:00:00", "HH:mm:ss"));
    const PMData = TimePeriodArray.filter((time) => moment(time.value, "HH:mm:ss") >= moment("12:00:00", "HH:mm:ss"));
    return (
      <TimePickerContainer ref={this.setTimepickerRef}>
        <TimePickerFormGroup>
          <TimePickerLabel>{'Time'}</TimePickerLabel>
          <TimePickerWrapper
            onClick={this.toggleTimepicker}
            className={(this.state.timePickerOpen) ? "timepickerOpen" : ""}
          >
            <TimePickerInput
              type="text"
              value={this.state.selectedTimeLabel}
              readOnly="readonly"
            />
          </TimePickerWrapper>
        </TimePickerFormGroup>
        <TimePickerContent
          timePickerOpen={this.state.timePickerOpen}
          selectedTime={this.state.selectedTime}
          handleSelect={this.handleSelect}
          handleTimePeriod={this.handleTimePeriod}
          selectedTimePeriod={this.state.selectedTimePeriod}
          AMData={AMData}
          PMData={PMData}
          leftPosition={this.props.leftPosition}
          selectedTimeId={this.state.selectedTimeId}
        />
      </TimePickerContainer>
    );
  }
}

TimePicker.propTypes = {
  handleSelect: PropTypes.func,
  selectedTime: PropTypes.string,
  leftPosition: PropTypes.string,
  selectedTimeId: PropTypes.number
};

TimePicker.defaultProps = {
  handleSelect: () => false,
  selectedTimeLabel: "09:00am",
  leftPosition: '0px',
  selectedTime: "09:00:00",
  selectedTimeId: 1
};

export default TimePicker;


// WEBPACK FOOTER //
// ./src/components/UI/TimePicker/TimePicker.js